// src/SignIn.js
import React, { useState } from "react";
import { useAuth } from "./AuthContext";

const SignIn = () => {
  const { signInWithGoogle, loading } = useAuth();
  const [busy, setBusy] = useState(false);

  const handleGoogle = async () => {
    try {
      setBusy(true);
      // This will redirect the browser to Supabase OAuth flow and
      // return to the configured redirect url (/dashboard) after auth.
      await signInWithGoogle();
      // We don't navigate here because signInWithGoogle uses a redirect.
    } catch (err) {
      console.error("Sign in failed", err);
    } finally {
      setBusy(false);
    }
  };

  const isDisabled = busy || loading;

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-[#111] text-[#eee] relative overflow-hidden">
      {/* Grid background like Playset landing */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)
          `,
          backgroundSize: "32px 32px",
          opacity: 1,
          zIndex: 0,
          maskImage: "radial-gradient(circle at center, white, transparent 75%)",
          WebkitMaskImage:
            "radial-gradient(circle at center, white, transparent 75%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 w-full max-w-md px-6">
        {/* Logo / title */}
        <div className="flex flex-col items-center mb-8">
          <div className="flex flex-row items-center gap-x-2 mb-2">
            <span className="text-3xl font-bebas tracking-wider">PLAYSET</span>
          </div>

        </div>

        {/* Card */}
        <div className="bg-[#161616] border border-[#2a2a2a] rounded-2xl shadow-md px-6 py-7 gap-y-4 flex flex-col items-center">
          <h2 className="font-bebas text-3xl tracking-wider text-center">
            Sign in
          </h2>

          <p className="font-nunito text-sm text-[#aaa] text-center max-w-sm">
            Sign in to manage your builds, playtests, and session recordings.
          </p>

          <button
            onClick={handleGoogle}
            disabled={isDisabled}
            className="flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed"
          >
            <img
              src={"/signInWithGoogle.svg"}
              alt="Sign in with Google"
              className="h-11 w-auto"
            />
          </button>

          {busy && (
            <div className="text-xs font-nunito text-[#ccc]">
              Starting sign in…
            </div>
          )}

          <div className="font-nunito text-[11px] text-[#777] text-center max-w-xs">
            By signing in with Google, you agree to Playset&apos;s{" "}
            <a href="/privacypolicy" className="underline hover:text-[#eee]">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a href="/termsofservice" className="underline hover:text-[#eee]">
              Terms of Service
            </a>
            .
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
